
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 41 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 3.333c5.755 0 9.818 4.662 9.278 11.3 2.909-.076 7.389 1.252 7.389 6.2a5.84 5.84 0 01-5.834 5.834H9.667a5.84 5.84 0 01-5.834-5.834c0-4.661 4.132-6.388 7.389-6.2-.279-7.03 3.68-11.3 9.278-11.3zM20.5 0C13.823 0 8.388 5.235 8.035 11.82 3.752 12.592.5 16.33.5 20.833A9.168 9.168 0 009.667 30h21.666a9.168 9.168 0 009.167-9.167c0-4.503-3.252-8.241-7.535-9.013C32.612 5.235 27.177 0 20.5 0zm6.667 16.667h-5v6.666h-3.334v-6.666h-5L20.5 10l6.667 6.667z","fill":"#fff"}})])
          )
        }
      }
    